export default {"src":"/customer-services/_next/static/media/logo-the-gift-list.6398cb3b.svg","height":12,"width":124,"blurWidth":0,"blurHeight":0};